import m from "mithril";
import Requester from "../../shared/request";
import Gateway from "../../shared/app_settings";
import ModalManager from "../../shared/modal";
import Toasts from "../../shared/toasts";
import i18n from "../../shared/i18n/i18n";

let saving = false;
let courseId, callback, days, modalId, errorMessage = "", reminderErrorMessage = [];

let lastSavedFirstReminder = null;
let lastSavedSecondReminder = null;
let lastSavedThirdReminder = null;

const MAX_DAYS = 1999999;
const MIN_DAYS = 1;
function handleDaysInput(e) {
    const inputValue = e.target.value;

    // Allow blank values
    if (inputValue === "" || inputValue === null) {
        days = null;
        errorMessage = "";
        return;
    }

    let val = parseInt(inputValue, 10);

    if (val > MAX_DAYS) {
        errorMessage = i18n.t("max_days_error");
        val = MAX_DAYS; // clamp value
    } else if  (val < MIN_DAYS){
        errorMessage = i18n.t("min_days_error");
    } else {
        errorMessage = ""; // clear error if valid
    }
    reminderErrorMessage = [];
    if (lastSavedFirstReminder !== null && val < lastSavedFirstReminder) {
        reminderErrorMessage.push( lastSavedFirstReminder + ' ' + i18n.t("days_before_expiry"));
    }
    if (lastSavedSecondReminder !== null && val < lastSavedSecondReminder) {
        reminderErrorMessage.push(lastSavedSecondReminder + ' ' + i18n.t("days_before_expiry"));
    }
    if (lastSavedThirdReminder !== null && val < lastSavedThirdReminder) {
        reminderErrorMessage.push(lastSavedThirdReminder + ' ' + i18n.t("days_before_expiry"));
    }

    days = val;
}

function saveDays() {
    if (errorMessage) {
        return;
    }

    saving = true;
    Requester.post(Gateway.admin + "courses/" + courseId + "/self-enrolment-expiry-days?days=" + (days ?? ""))
        .then(function (course) {
            ModalManager.close(modalId);
            Toasts.add("success", i18n.t("saved_changes"), "");
            if (callback) {
                callback(course);
            }
        }).catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response?.properties?.errorCode || "unknown_error"));
        }).finally(function () {
            errorMessage = null;
            reminderErrorMessage = [];
            saving = false;
        });
}

const Modal_Self_Enrolment_Expiry_Edit = {
    oninit: function(vnode) {
        courseId = vnode.attrs.courseId;
        callback = vnode.attrs.callback;
        days = vnode.attrs.days;
        lastSavedFirstReminder = vnode.attrs.lastSavedFirstReminder;
        lastSavedSecondReminder = vnode.attrs.lastSavedSecondReminder;
        lastSavedThirdReminder = vnode.attrs.lastSavedThirdReminder;
        errorMessage = "";
    },
    view: function () {
        return [
            m(".form-section", [
                m("span", i18n.t("set_enrolment_expiry_message")),
                m(".form-label mt-2", i18n.t("number_of_days")),
                m("input[type=number]", {
                    max: MAX_DAYS,
                    value: days ?? "",
                    placeholder: i18n.t("days"),
                    oninput: handleDaysInput
                }),
                errorMessage && m("div.text-danger.text-sm.mt-1", errorMessage),
                reminderErrorMessage.length > 0 && m(".label-circle-message label-error mt-2", [
                    m("div", [
                        m("strong", i18n.t("warning") + ": "),
                        i18n.t("update_enrolment_expiry_warning") + ': ',
                        reminderErrorMessage.map(msg =>
                            m(".label-circle-message label-secondary ml-2 mt-2", [
                                m("div", [msg])
                            ])
                        ),
                    ])

                ]),
                m(".label-circle-message label-warning mt-2", [
                    m("div", [
                    m("strong", i18n.t("warning") + ": "),
                    i18n.t("set_enrolment_expiry_warning")
                    ])
                ])
            ]),
            m(".form-buttons", [
                saving ? m("button.btn-text no-click", [i18n.t("saving"), m(".loading-dots")])
                : m("button", {onclick: saveDays}, i18n.t("save"))
            ])
        ];
    },
    setModalId: function(id) {
        modalId = id;
    }
};
export default Modal_Self_Enrolment_Expiry_Edit;
